window.discoveryDesignDetailAfterCallBack = function(data) {
  // console.log('Original data--', typeof data, data);
  document.querySelectorAll('[data-rank]').forEach(el => {
    el.style.order = el.getAttribute('data-rank');
  });

  const fetchPromises = data.map(function(each) {
    const ProductHandle = each.handle;
    const ProductURL = `/products/${ProductHandle}?sections=product-show-buy-button`;

    return fetch(ProductURL)
      .then(res => res.json())
      .then(result => {
        const rawHTML = result['product-show-buy-button'] || '';
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = rawHTML;
        const contentText = tempDiv.textContent.trim(); // Ex: "product_showbuybutton-0"
        each.section_html = contentText || null;

        return each;
      })
      .catch(err => {
        console.error(`Error fetching section for ${each.handle}:`, err);
        each.section_html = null;
        return each;
      });
  });

  Promise.all(fetchPromises).then(updatedData => {
    const ProductRows = document.querySelectorAll('.dc_table_grid');
    updatedData.forEach((product, i) => {
      const sectionValue = product.section_html;
      const numericValue = sectionValue?.split('product_showbuybutton-').pop();
      // console.log(`✅ [${i}] ${product.handle} → section_html: ${sectionValue}`);
      if (numericValue === '0' && ProductRows[i]) {
        const addButton = ProductRows[i].querySelector('.dc_add_tigger');
        if (addButton) {
          addButton.style.display = 'none';
          // console.log(`🚫 Hiding button for product at row ${i}: ${product.handle}`);
        }
      }
    });
  });
};